/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

/**
 * Body for ``POST /enrollments/{id}/pause``.
 *
 * ``auto_resume_at`` is optional — the workflow simply schedules a
 * resume signal at that time (forwarded to the workflow via the
 * ``resume_signal(at=...)`` payload when it fires).
 */
export interface _PauseRequest {
  auto_resume_at?: unknown;
}
